/* eslint-disable max-classes-per-file */
import { IArbetsorderHandelssortiment } from "~app/features/planera/model/IArbetsorderHandelssortiment";
import { IProduktvalRow, IProduktvalRowProduktInstruktion, ProduktvalRowBase } from "~app/features/planera/produktval/produktval.models";
import { JusteraArbetsorderProduktKvantitetCommand } from "../commands/JusteraArbetsorderProduktKvantitetCommand";
import { UpdateArbetsorderProduktinstruktionCommand } from "../commands/UpdateArbetsorderProduktinstruktionCommand";
import { ArbetsorderWrapper } from "../planera-detail/planera-detail-models";

export class ProduktvalRow extends ProduktvalRowBase implements IProduktvalRow  {
    collapsed: boolean;

    constructor(private readonly arbetsorderWrapper: ArbetsorderWrapper) {
        super();
        this.produktinstruktioner = [];
        this.collapsed = true;
    }

    setJusteradKvantitet(newValue: number): void {
        this.arbetsorderWrapper.arbetsorder
            .commandManager.updateCommand(new JusteraArbetsorderProduktKvantitetCommand(this.handelssortimentId, this.arbetsorderWrapper.id, this.produktId, newValue));
        this.justeradKvantitet = newValue;
    }

    setMedTillUtbytessimulering(newValue: number): void {
        const prevValue = this.medTillUtbytessimulering;
        if (prevValue && this.produktId) {
            // prev is no longer medIUtbytessimulering
            const cmd = new UpdateArbetsorderProduktinstruktionCommand(this.handelssortimentId, this.produktId, this.arbetsorderWrapper.id, prevValue);
            cmd.medIUtbytessimulering = false;
            this.arbetsorderWrapper.arbetsorder.commandManager.updateCommand(cmd);
        }

        if (newValue && this.produktId) {
            // newvalue is medIUtbytessimulering
            const cmd = new UpdateArbetsorderProduktinstruktionCommand(this.handelssortimentId, this.produktId, this.arbetsorderWrapper.id, newValue);
            cmd.medIUtbytessimulering = true;
            this.arbetsorderWrapper.arbetsorder.commandManager.updateCommand(cmd);
        }

        this.medTillUtbytessimulering = newValue;
    }

    produktinstruktionValueFormatter = (item: Produktinstruktion) => item && item.id;

    produktinstruktionDisplayValueFormatter = (item: Produktinstruktion) => item && item.namnInkPuid;
}

export class Produktinstruktion implements IProduktvalRowProduktInstruktion {
    namn: string;
    puid: string;
    id: number;

    get namnInkPuid() {
        return `${this.namn} PUID:  ${this.puid}`;
    }

    constructor(namn, id, puid) {
        this.namn = namn;
        this.id = id;
        this.puid = puid;
    }
}

export interface IProduktionsmall {
    id: number;
    benamning: string;
    aktiv: boolean;
    udate: Date;
    rowVersion: string;
    handelssortiment: IArbetsorderHandelssortiment[];
    vardekap: boolean;
}

export interface IHandelssoritmentgruppInformation {
    handelssortimentsgruppNamn: string;
    handelssortimentsgruppVolym: number;
}
